import size from 'lodash/size'
import some from 'lodash/some'

interface OrderData {
  isCancelled: boolean
  orderLookProducts: []
}

export const hasItemsInOrder = (order: OrderData): boolean => size(order?.orderLookProducts) > 0

export const hasItemsInAnyOrder = (orders: OrderData[]): boolean =>
  some(orders, ({orderLookProducts}) => size(orderLookProducts) > 0)

export const isActiveOrder = (order: OrderData): boolean =>
  !order.isCancelled && hasItemsInOrder(order)
